import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { AlbumForm } from 'client/shared/components';

import SongForm from './song-form';

@observer
class FormList extends React.Component {
	state = {
		isNewAlbum: false
	};

	render () {
		const { songList = [] } = this.props;
		const { isNewAlbum } = this.state;

		return (
			<div>
				<div className="grid-x">
					<div className="cell">
						<h4>Edit Song Info</h4>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell shrink">
						<button className="button clear secondary padding-left-0" onClick={ this.onClick }>Back to upload</button>
					</div>

					<div className="cell auto small-offset-6">
						<p className="float-right">Add all songs to a new album?</p>
						<div className="switch tiny flot-left">
							<input className="switch-input" id="yes-no" type="checkbox" name="exampleSwitch" onChange={ this.onChange } />
							<label className="switch-paddle" htmlFor="yes-no">
								<span className="show-for-sr">Add all songs to a new album?</span>
								<span className="switch-active" aria-hidden="true">Yes</span>
								<span className="switch-inactive" aria-hidden="true">No</span>
							</label>
						</div>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						{ isNewAlbum ? <AlbumForm /> : null }
					</div>
				</div>

				<div className="grid-x">
					<div className="cell">
						{ songList.map((song) => <SongForm song={ song } />) }
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onClick () {
		const { songsStore } = this.props;
	}

	@autobind
	onChange ({ target }) {
		this.setState({
			isNewAlbum: target.checked
		});
	}
}

export default FormList;
